export enum Status {
  NEW = 'New',
  SUBMITTED_FOR_REVIEW = 'Submitted for review',
  QUOTE_SUBMITTED = 'Quote submitted',
  IN_PROGRESS = 'In progress',
  PENDING_ACCEPTANCE = 'Pending acceptance',
  COMPLETE = 'Complete',
  ARCHIVED = 'Archived',
  DELETED = 'Deleted',
}

export enum ActivityEvent {
  MESSAGE = 'Message',
  CREATED = 'Created',
  SUBMITTED_FOR_REVIEW = 'Submitted for review',
  QUOTE_SUBMITTED = 'Quote submitted',
  QUOTE_UPDATED = 'Quote updated',
  NEW_DOCUMENT = 'New document',
  CUST_ADD_PO = 'Customer added P/O docs',
  CUST_SUBMIT_PAYMENT = 'Customer submitted payment',
  CUST_SIGNED_AC = 'Customer signed acceptance criteria',
  CUST_SIGNED_SA = 'Customer signed service agreement',
  AE_ACCEPTS_PO = 'AE accepts PO docs',
  DELETED = 'Deleted',
  AE_SUBMITS_DELIVERABLES = 'AE submitted deliverables',
  PROJECT_COMPLETED = 'Project completed',
  PROJECT_ARCHIVED = 'Project was archived',
}

export enum Role {
  USER = 'User',
  AE = 'AE',
  MANAGER = 'Manager',
  SUPPORT = 'Support',
}

export enum AddressType {
  SHIPPING = 'Shipping',
  RETURN = 'Return',
}
